import React from "react";
import { Tooltip } from "antd";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";

const WorkorderLink = ({ id, text, action }) => {
  const { navigateToWorkorderDetail } = useSmartNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    if (action) {
      navigateToWorkorderDetail(id);
    }
  };

  return (
    <Tooltip title={text}>
      {/* 与树形缩进同一行：block 会换行撑高单元格；inline-block + max-width 在 table-layout:fixed 下省略号 */}
      <div
        className="workorder-issue-link-ellipsis"
        style={{
          display: "inline-block",
          verticalAlign: "middle",
          maxWidth: "calc(100% - 48px)",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          lineHeight: "22px",
        }}
      >
        <a
          onClick={handleClick}
          style={{
            color: "inherit",
            cursor: "pointer",
          }}
        >
          {text}
        </a>
      </div>
    </Tooltip>
  );
};

export default WorkorderLink;

